<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  name: "PieChart",
  props: ["data", "labels"],
  data() {
    return {
      chartData: {
        labels: this.labels,
        datasets: [
          {
            borderWidth: 1,
            borderColor: [
              "rgba(3, 112, 49)",
              "rgba(19, 0, 105)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
            ],
            backgroundColor: [
              "rgba(6, 209, 91)",
              "rgba(39, 0, 214)",
              "rgba(255, 206, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
            ],
            data: this.data,
          },
        ],
      },
      options: {
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: true,
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>